<script lang="ts">
  import QRCode from 'qrcode';

  let { value }: { value: string } = $props();
  let source = $state('');
  $effect(() => {
    QRCode.toDataURL(value, { width: 420, margin: 2, color: { dark: '#20202aff', light: '#fffdf8ff' }, errorCorrectionLevel: 'M' }).then((url) => source = url);
  });
</script>

<div class="qr-frame">
  {#if source}<img src={source} alt="QR code containing the signer connection request" />{/if}
  <span aria-hidden="true">✦</span>
</div>

<style>
  .qr-frame { position: relative; width: min(210px, 60vw); margin: 0 auto; padding: 10px; border: 1px solid var(--line-strong); background: var(--surface); box-shadow: 8px 9px 0 color-mix(in srgb, var(--aqua) 24%, transparent); transform: rotate(-1deg); }
  img { display: block; width: 100%; }
  span { position: absolute; right: -13px; top: -15px; display: grid; place-items: center; width: 34px; height: 34px; border-radius: 50%; background: var(--gold); color: var(--violet-dark); animation: twinkle 1.8s ease-in-out infinite; }
  @keyframes twinkle { 50% { transform: rotate(18deg) scale(1.08); } }
  @media (prefers-reduced-motion: reduce) { span { animation: none; } }
</style>
